type ArrowRightProps = {
    width?: string;
    height?: string;
    stroke?: string;
};
const ArrowRight = ({ width, height, stroke }: ArrowRightProps) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width || '24'}
        height={height || '24'}
        viewBox='0 0 24 24'
        fill='none'
        stroke={stroke || 'currentColor'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
    >
        <line x1='0' y1='12' x2='23' y2='12'></line>
        <polyline points='12 0 23 12 12 24'></polyline>
    </svg>
);

export default ArrowRight;
